import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCookies } from 'react-cookie';
import { Grid, Cell, Flex } from '@phishtool/ui';
import { StyledCookieBannerWrapper, StyledCookieButton } from './styled';
const cookieName = 'cookie-banner-hidden';
const CookieBanner = () => {
    const [cookies, setCookie] = useCookies([cookieName]);
    const hasCookie = !!cookies[cookieName];
    return hasCookie ? null : (_jsx(StyledCookieBannerWrapper, { children: _jsx(Grid, { children: _jsx(Cell, { children: _jsxs(Flex, Object.assign({ justify: "center", align: "center", gap: "medium" }, { children: [_jsx("p", { children: "We only use cookies that are strictly necessary for our website and services to work." }), _jsx(StyledCookieButton, Object.assign({ onClick: () => setCookie(cookieName, 'true') }, { children: "OK" }))] })) }) }) }));
};
export default CookieBanner;
